export const cardsSizes = {
  desktop: {
    width: 180,
    height: 112,
  },
  mobile: {
    width: 257,
    height: 160,
  },
};

export const cardsData = [
  {
    img: '/lp/cards-benefits-june-2025/card-gold.webp',
    alt: 'card-gold',
    title: 'title.gold',
    description: 'description.gold',
  },
  {
    img: '/lp/cards-benefits-june-2025/card-platinum.webp',
    alt: 'card-platinum',
    title: 'title.platinum',
    description: 'description.platinum',
  },
  {
    img: '/lp/cards-benefits-june-2025/card-diamond.webp',
    alt: 'card-diamond',
    title: 'title.diamond',
    description: 'description.diamond',
  },
];
